import { OfferItemOneOffModel, OfferItemRecurringDurationUnit, OfferItemRecurringModel, OfferItemRecurringTieredType, OfferItemRecurringUsageTieredType, OfferItemRecurringUsageType, OfferItemRow, OfferItemType, OfferRow } from 'namirasoft-payment';
import { MoneyFormatter, NSSpace, NSSpaceSizeType } from 'namirasoft-site-react';
import Styles from './NSPOfferItemCard.module.css';
import { NSPOfferItemCardPriceDominant } from './NSPOfferItemCardPriceDominant';
import { NSPOfferItemCardPriceLine } from './NSPOfferItemCardPriceLine';
import { NSPOfferItemCardPriceTable } from './NSPOfferItemCardPriceTable';

export interface NSPOfferItemCardProps 
{
    offer: OfferRow;
    offer_item: OfferItemRow;
}

function NSPOfferItemCard(props: NSPOfferItemCardProps)
{
    if (props.offer_item.type === OfferItemType.OneOff)
    {
        if (props.offer_item.one_off_model === OfferItemOneOffModel.Flat)
        {
            let price = props.offer_item.one_off_flat_amount ?? 0;
            if (!props.offer_item.dominant)
                return <NSPOfferItemCardPriceLine
                    image={props.offer_item.logo}
                    price={price}
                    currency={props.offer_item.currency}
                    name={props.offer_item.name}
                    description={[
                        props.offer_item.description
                    ].filter(x => x).join("<br>")}
                />;
            return <NSPOfferItemCardPriceDominant
                price={price}
                currency={props.offer_item.currency}
                was={props.offer_item.was_price}
                description={props.offer_item.description}
            />;
        }
        else if (props.offer_item.one_off_model === OfferItemOneOffModel.Package)
        {
            let price = props.offer_item.one_off_package_amount ?? 0;
            // let per = `With a ceiling of every ${props.offer_item.one_off_package_per_value} ${props.offer_item.one_off_package_per_unit}`;
            if (!props.offer_item.dominant)
                return <NSPOfferItemCardPriceLine
                    image={props.offer_item.logo}
                    price={price}
                    currency={props.offer_item.currency}
                    name={props.offer_item.name}
                    description={[
                        // per,
                        props.offer_item.description
                    ].filter(x => x).join("<br>")}
                />;
            return <NSPOfferItemCardPriceDominant
                price={price}
                currency={props.offer_item.currency}
                was={props.offer_item.was_price}
                // per={per}
                description={props.offer_item.description}
            />;
        }
        else if (props.offer_item.one_off_model === OfferItemOneOffModel.Choosable)
        {
            return <>
                <div className={Styles.nsp_offer_item_card_description} >
                    <h5 style={{ textAlign: "center" }}>You will choose how much to pay</h5>
                </div>
            </>;
        }
    }
    else if (props.offer_item.type === OfferItemType.Recurring)
    {
        let recurring_duration_value = props.offer_item.recurring_duration_value ?? 0;
        let recurring_duration_unit = props.offer_item.recurring_duration_unit ?? OfferItemRecurringDurationUnit.Day;
        let duration_value_unit = `${recurring_duration_value > 1 ? recurring_duration_value : ""} ${recurring_duration_unit.toLocaleLowerCase()}${recurring_duration_value > 1 ? "s" : ""}`;
        function toMonthly(price: number)
        {
            let one_month = 0;
            if (recurring_duration_unit === OfferItemRecurringDurationUnit.Day)
                one_month = price * 30;
            if (recurring_duration_unit === OfferItemRecurringDurationUnit.Week)
                one_month = price * 52 / 12;
            if (recurring_duration_unit === OfferItemRecurringDurationUnit.Month)
                one_month = price;
            if (recurring_duration_unit === OfferItemRecurringDurationUnit.Year)
                one_month = price / 12;
            if (recurring_duration_value)
            {
                let ans = one_month / recurring_duration_value;
                return Math.round(ans * 100) / 100;
            }
            return 0;
        }

        if (props.offer_item.recurring_model === OfferItemRecurringModel.Flat)
        {
            let price = props.offer_item.recurring_flat_amount ?? 0;
            let price_monthly = toMonthly(price);
            let subtitle = `You pay ${new MoneyFormatter(undefined, props.offer_item.currency).format(price)} every ${duration_value_unit}`;
            if (!props.offer_item.dominant)
                return <NSPOfferItemCardPriceLine
                    image={props.offer_item.logo}
                    price={price}
                    currency={props.offer_item.currency}
                    name={props.offer_item.name}
                    description={[
                        subtitle,
                        props.offer_item.description
                    ].filter(x => x).join("<br>")}
                />;
            return <NSPOfferItemCardPriceDominant
                price={price_monthly}
                currency={props.offer_item.currency}
                was={props.offer_item.was_price}
                per="per Month"
                subtitle={subtitle}
                description={props.offer_item.description}
            />;
        }
        else if (props.offer_item.recurring_model === OfferItemRecurringModel.Package)
        {
            let price = props.offer_item.recurring_package_amount ?? 0;
            let price_monthly = toMonthly(price);
            let subtitle = `You pay ${new MoneyFormatter(undefined, props.offer_item.currency).format(price)} every ${duration_value_unit}`;
            // let per = `With a ceiling of every ${props.offer_item.recurring_package_per_value} ${props.offer_item.recurring_package_per_unit}`;
            if (!props.offer_item.dominant)
                return <NSPOfferItemCardPriceLine
                    image={props.offer_item.logo}
                    price={price}
                    currency={props.offer_item.currency}
                    name={props.offer_item.name}
                    description={[
                        subtitle,
                        // per,
                        props.offer_item.description
                    ].filter(x => x).join("<br>")}
                />;
            return <NSPOfferItemCardPriceDominant
                price={price_monthly}
                currency={props.offer_item.currency}
                was={props.offer_item.was_price}
                per="per Month"
                subtitle={subtitle}
                description={props.offer_item.description}
            />;
        }
        else if (props.offer_item.recurring_model === OfferItemRecurringModel.Tiered)
        {
            let subtitle = `You pay every ${duration_value_unit}`;
            return <NSPOfferItemCardPriceTable
                volume_or_graduated={props.offer_item.recurring_tiered_type === OfferItemRecurringTieredType.Volume}
                amounts={props.offer_item.recurring_tiered_amounts}
                currency={props.offer_item.currency}
                was={props.offer_item.was_price}
                subtitle={subtitle}
                description={props.offer_item.description}
            />;
        }
        else if (props.offer_item.recurring_model === OfferItemRecurringModel.Usage)
        {
            let title = "You Pay as You Go";
            let subtitle = `Charges based on usage every ${duration_value_unit}`;
            if (props.offer_item.recurring_usage_type === OfferItemRecurringUsageType.Unit)
            {
                let price = props.offer_item.recurring_usage_unit_amount ?? 0;
                if (!props.offer_item.dominant)
                    return <NSPOfferItemCardPriceLine
                        image={props.offer_item.logo}
                        price={price}
                        currency={props.offer_item.currency}
                        name={(props.offer_item.recurring_usage_unit ?? props.offer_item.name)}
                        description={[
                            title,
                            subtitle,
                            props.offer_item.description
                        ].filter(x => x).join("<br>")}
                    />;
                return <>
                    <div className={Styles.nsp_offer_item_card_description}>
                        <h5>{title}</h5>
                    </div>
                    <NSPOfferItemCardPriceDominant
                        price={price}
                        currency={props.offer_item.currency}
                        was={props.offer_item.was_price}
                        per={props.offer_item.recurring_usage_unit ?? undefined}
                        subtitle={subtitle}
                        description={props.offer_item.description}
                    />
                </>;
            }
            else if (props.offer_item.recurring_usage_type === OfferItemRecurringUsageType.Package)
            {
                let price = props.offer_item.recurring_usage_package_amount ?? 0;
                // let per = `With a ceiling of every ${props.offer_item.recurring_usage_package_per_value} ${props.offer_item.recurring_usage_package_per_unit}`;
                if (!props.offer_item.dominant)
                    return <NSPOfferItemCardPriceLine
                        image={props.offer_item.logo}
                        price={price}
                        currency={props.offer_item.currency}
                        name={(props.offer_item.recurring_usage_unit ?? props.offer_item.name)}
                        description={[
                            title,
                            subtitle,
                            // per,
                            props.offer_item.description
                        ].filter(x => x).join("<br>")}
                    />;
                return <>
                    <div className={Styles.nsp_offer_item_card_description}>
                        <h5>{title}</h5>
                    </div>
                    <NSPOfferItemCardPriceDominant
                        price={price}
                        currency={props.offer_item.currency}
                        was={props.offer_item.was_price}
                        per={[
                            props.offer_item.recurring_usage_unit
                            // , per
                        ].filter(x => x).join("<br>")}
                        subtitle={subtitle}
                        description={props.offer_item.description}
                    />
                </>;
            }
            else if (props.offer_item.recurring_usage_type === OfferItemRecurringUsageType.Tiered)
            {
                return <>
                    <div className={Styles.nsp_offer_item_card_description}>
                        <h5>{title}</h5>
                        <NSSpace size={NSSpaceSizeType.MINI} />
                    </div> <NSPOfferItemCardPriceTable
                        volume_or_graduated={props.offer_item.recurring_usage_tiered_type === OfferItemRecurringUsageTieredType.Volume}
                        amounts={props.offer_item.recurring_usage_tiered_amounts}
                        currency={props.offer_item.currency}
                        was={props.offer_item.was_price}
                        per={props.offer_item.recurring_usage_unit ?? undefined}
                        subtitle={subtitle}
                        description={props.offer_item.description}
                    />
                </>;
            }
        }
    }
    return <></>;
}

export default NSPOfferItemCard;